<template>
  <div id="digits-wrapper" class="digits-wrapper">
    <input
      id="otc-1"
      inputtype="numeric"
      inputmode="numeric"
      class="form-control"
      v-model="digit1"
      type="text"
      maxLength="1"
      size="1"
      min="0"
      max="9"
      pattern="[0-9]{1}"
    />
    <input
      inputtype="numeric"
      inputmode="numeric"
      class="form-control"
      v-model="digit2"
      type="text"
      maxLength="1"
      size="1"
      min="0"
      max="9"
      pattern="[0-9]{1}"
    />
    <input
      inputtype="numeric"
      inputmode="numeric"
      class="form-control"
      v-model="digit3"
      type="text"
      maxLength="1"
      size="1"
      min="0"
      max="9"
      pattern="[0-9]{1}"
    />
    <input
      inputtype="numeric"
      inputmode="numeric"
      class="form-control"
      v-model="digit4"
      type="text"
      maxLength="1"
      size="1"
      min="0"
      max="9"
      pattern="[0-9]{1}"
    />
    <input
      inputtype="numeric"
      inputmode="numeric"
      class="form-control"
      v-model="digit5"
      type="text"
      maxLength="1"
      size="1"
      min="0"
      max="9"
      pattern="[0-9]{1}"
    />
    <input
      inputtype="numeric"
      inputmode="numeric"
      class="form-control"
      v-model="digit6"
      type="text"
      maxLength="1"
      size="1"
      min="0"
      max="9"
      pattern="[0-9]{1}"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      digit1: "",
      digit2: "",
      digit3: "",
      digit4: "",
      digit5: "",
      digit6: "",
    };
  },
  mounted() {
    this.handleKeys();
  },
  watch: {
    digits(value) {
      if (this.valid) {
        this.$emit("input", value);
      }
    },
    showOverlay(val) {
      if (val === false) {
        this.clear();
      }
    },
  },
  computed: {
    ...mapGetters(["showOverlay"]),

    valid() {
      return (
        this.digit1 &&
        this.digit2 &&
        this.digit3 &&
        this.digit4 &&
        this.digit5 &&
        this.digit6
      );
    },
    digits() {
      return (
        this.digit1 +
        this.digit2 +
        this.digit3 +
        this.digit4 +
        this.digit5 +
        this.digit6
      );
    },
  },
  methods: {
    handleKeys() {
      let in1 = document.getElementById("otc-1");
      let ins = document
        .getElementById("digits-wrapper")
        .querySelectorAll('input[type="text"]');
      ins.forEach(function (input) {
        /**
         * Control on keyup to catch what the user intent to do.
         * I could have check for numeric key only here, but I didn't.
         */
        input.addEventListener("keyup", function (e) {
          // Break if Shift, Tab, CMD, Option, Control.
          if (
            e.keyCode === 16 ||
            e.keyCode == 9 ||
            e.keyCode == 224 ||
            e.keyCode == 18 ||
            e.keyCode == 17
          ) {
            return;
          }

          // On Backspace or left arrow, go to the previous field.
          if (
            (e.keyCode === 8 || e.keyCode === 37) &&
            this.previousElementSibling &&
            this.previousElementSibling.tagName === "INPUT"
          ) {
            this.previousElementSibling.select();
          } else if (e.keyCode !== 8) {
            if (this.nextElementSibling) this.nextElementSibling.select();
            else in1.select();
          }
        });
        input.addEventListener("keydown", function (e) {
          var key = e.keyCode;
          if (
            key === 9 ||
            (key >= 48 && key <= 57) ||
            (key >= 96 && key <= 105)
          ) {
            return true;
          }

          e.preventDefault();
          return false;
        });
        /**
         * Better control on Focus
         * - don't allow focus on other field if the first one is empty
         * - don't allow focus on field if the previous one if empty (debatable)
         * - get the focus on the first empty field
         */
        input.addEventListener("focus", function (e) {
          e.target.select();
        });
      });
    },
    clear() {
      this.digit1 = "";
      this.digit2 = "";
      this.digit3 = "";
      this.digit4 = "";
      this.digit5 = "";
      this.digit6 = "";
    },
  },
};
</script>

<style lang="scss">
.digits-wrapper {
  display: flex;
  input {
    flex: 1;
    min-width: 0;
    padding: 0.375rem 0.75rem;
    margin-left: 5px;
    text-align: center;
    outline: none;
    &:first-child {
      margin-left: 0;
    }
    &::selection {
      background: transparent;
    }
    &:focus {
      border-bottom: 2px solid;
    }
  }
}
</style>
